var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8756 18.8332H6.86758C4.9189 18.8332 3.33333 17.2477 3.33333 15.299V9.85237C3.33333 7.90369 4.9189 6.31812 6.86758 6.31812H13.8756C15.8243 6.31812 17.4098 7.90369 17.4098 9.85237V15.299C17.4098 17.2477 15.8243 18.8332 13.8756 18.8332ZM6.86758 7.67372C5.66932 7.67372 4.68893 8.65411 4.68893 9.85237V15.299C4.68893 16.4972 5.66932 17.4776 6.86758 17.4776H13.8756C15.0738 17.4776 16.0542 16.4972 16.0542 15.299V9.85237C16.0542 8.65411 15.0738 7.67372 13.8756 7.67372H6.86758Z",
    fill: "#289FC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.426 14.6213C11.5156 14.6213 12.3989 13.738 12.3989 12.6484C12.3989 11.5588 11.5156 10.6755 10.426 10.6755C9.33642 10.6755 8.45312 11.5588 8.45312 12.6484C8.45312 13.738 9.33642 14.6213 10.426 14.6213Z",
    fill: "#289FC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9408 6.80231H13.5972C13.5972 4.98677 12.1206 3.52223 10.3172 3.52223C8.51374 3.52223 7.0371 4.99887 7.0371 6.80231H5.66939C5.66939 4.24845 7.75121 2.16663 10.3051 2.16663C12.8589 2.16663 14.9408 4.24845 14.9408 6.80231Z",
    fill: "#289FC9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.c036461d9a69a9ab9b64730d80dc92b4.svg";
export { ForwardRef as ReactComponent };